<mat-progress-bar
	mode="indeterminate"
	*ngIf="!isDataLoaded"
	class="sdp-progress-bar"
></mat-progress-bar>
<h2>
	{{ "saml-aliases.page.title" | translate }}
</h2>
<div class="sdp-section-header-description">
	<div class="sdp-section-header-description">
		{{ "saml-aliases.page.info" | translate }}
	</div>
	<div
		class="sdp-button-create-container-no-card"
		*ngIf="providerData.length > 0"
	>
		<button
			mat-raised-button
			color="primary"
			(click)="showCreateSamlAlias()"
			class="sdp-button-create"
		>{{ "sdp.label.add" | translate }}</button>
	</div>
</div>
<div class="sdp-clear"></div>
<div *ngIf="providerData.length > 0; else noProviders">
	<mat-card class="sdp-administrative-table-card">
		<sdp-generic-table
			[columnSchema]="columnSchema"
			[tableName]="'SAML Groups'"
			[tableData]="data"
			[rows]="10"
		></sdp-generic-table>
	</mat-card>
</div>
<ng-template #noProviders>
	<div
		*ngIf="isDataLoaded"
		class="sdp-saml-alias-no-providers-container"
	>
		<mat-card>
			{{ "saml-alias.no.idp-before" | translate }}
			<a
				class="sdp-link sdp-gateway-activate-link"
				routerLink="/administration/users"
			>{{ "saml-alias.no.idp-link" | translate }}</a>
			{{ "saml-alias.no.idp-after" | translate }}
		</mat-card>
	</div>
</ng-template>
<router-outlet></router-outlet>